module.exports = __webpack_public_path__ + "static/media/undertale.2a7e9363.mp3";